import { ReactNode } from 'react'
import type { TableNode } from '@table-library/react-table-library/types/table'
import { useTranslation } from 'libs/i18n'
import { ContextMenu } from 'shared/components'
import type { Option } from 'shared/components/ContextMenu/types'
import type { CardTableColumn } from 'styles/table'
import type { AreaTypeItem } from 'features/areaTypes/types/areaTypes.types'

type UseColumnsProps = {
	menuOptions: Option[]
}

const cell = (render: (boothType: AreaTypeItem) => ReactNode) => (node: TableNode) =>
	render(node as unknown as AreaTypeItem)

export const useColumns = ({ menuOptions }: UseColumnsProps): CardTableColumn[] => {
	const { t } = useTranslation()

	return [
		{
			label: t('Name'),
			width: 'minmax(160px, 1fr)',
			padding: '12px 16px',
			renderCell: cell((item) => (
				<span className="block truncate text-[13px] font-semibold text-foreground">
					{item.name}
				</span>
			)),
			select: true,
			pinLeft: true
		},
		{
			label: t('Description'),
			width: 'minmax(240px, 2.8fr)',
			padding: '12px 16px',
			renderCell: cell((item) => (
				<span className="block truncate text-[13px] text-muted-foreground">
					{item.description || '—'}
				</span>
			))
		},
		{
			label: '',
			width: '48px',
			padding: '12px 8px',
			renderCell: cell((item) => (
				<ContextMenu
					dataId={item.id}
					item={item}
					options={menuOptions}
					label={t('Actions for {{ name }}', { name: item.name })}
				/>
			))
		}
	]
}
